import type { ThirdPartyDeviceType } from "verdi-common";

import type { MarkerAppearance } from "./components/marker-appearances";

/**
 * Device types that have migrated to this layer, and the appearance each one draws in.
 *
 * Transitional, like the split it feeds: once every type has migrated this file says nothing, because
 * the answer is always yes. Migrating a source across starts by adding its types here.
 */

const MIGRATED_DEVICE_APPEARANCES = {
    davisWeatherStation: "weatherStation",
} as const satisfies Partial<Record<ThirdPartyDeviceType, MarkerAppearance>>;

/**
 * How a migrated device type draws, or undefined where the legacy layer still owns it.
 *
 * The map reaches an appearance through a projection instead. This is for the places outside the map
 * that draw the same disc — the device card header today.
 */
export const appearanceForDeviceType = (deviceType: string | undefined): MarkerAppearance | undefined =>
    MIGRATED_DEVICE_APPEARANCES[deviceType as keyof typeof MIGRATED_DEVICE_APPEARANCES];

/** Whether this layer is responsible for a device type, rather than the legacy one */
export const isMigratedDeviceType = (deviceType: string | undefined) =>
    appearanceForDeviceType(deviceType) !== undefined;
